import { render } from "./InfoVue.vue?vue&type=template&id=bb1aee8c"
import script from "./InfoVue.vue?vue&type=script&lang=js"
export * from "./InfoVue.vue?vue&type=script&lang=js"

import "./InfoVue.vue?vue&type=style&index=0&id=bb1aee8c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__